import React from 'react'
import { Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { withAuthenticatedRoute, useAuth } from 'lib/auth'
import { ThemeProvider, useTheme } from '@material-ui/core/styles'
import { Box, Container, Link } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import HelpOutlineIcon from 'components/material-symbol/icons/HelpOutline'
import themes, { extendTheme } from 'themes'
import PGALogo from 'images/pga-logo-navy.png'
import { useSupportContactActions } from 'lib/support'
import CoachLandingPage from 'pages/landing'
import Golfer from './tiles/golfer'
import PgaCoach from './tiles/pga-coach'
import WelcomeFooter from './welcome-footer'
import { useStyles } from './styles'

export const WelcomePage = () => {
  const classes = useStyles()
  const { openSupport } = useSupportContactActions()
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))

  return (
    <Box className={classes.page}>
      <Box className={classes.main}>
        <AppBar position="fixed" square className={classes.appBar}>
          <Container>
            <Toolbar disableGutters>
              <img src={PGALogo} alt="PGA logo" className={classes.logo} />
              <div className={classes.filler} />
              <Link
                component="button"
                type="button"
                onClick={openSupport}
                className={classes.helpButton}
                underline="none"
              >
                <HelpOutlineIcon
                  className={classes.helpButtonIcon}
                  fontSize="small"
                  opticalSize={20}
                />
                Help
              </Link>
            </Toolbar>
          </Container>
        </AppBar>

        <Box className={classes.hero}>
          <Container>
            <Box className={classes.heroContent}>
              <Typography className={classes.eyebrow} component="p">
                Welcome to MyPGA
              </Typography>
              <Typography component="h1" className={classes.title}>
                Choose your PGA experience.
              </Typography>
              <Typography className={classes.heroSubtext}>
                Select the experience that best matches how you&apos;ll use
                MyPGA.
              </Typography>
            </Box>
          </Container>
        </Box>

        <Container className={classes.cardsSection}>
          <Grid container justifyContent="center">
            <Grid
              container
              item
              md={10}
              direction="row"
              spacing={isMobile ? 2 : 3}
            >
              <Grid item md={6} sm={6} xs={12}>
                <Golfer />
              </Grid>
              <Grid item md={6} sm={6} xs={12}>
                <PgaCoach />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <WelcomeFooter />
    </Box>
  )
}

/*
This is used as work-around related to Intercom Product Tours
More Details: https://www.intercom.com/help/en/articles/3049411-why-can-t-i-build-a-product-tour#h_2b0ef1dcd9
*/
const isIntercomOverride = !!window.location.search.match(/intercomOverride/i)

export const WelcomeShell = () => {
  const { isLoggedIn, isCoach, isConsumer } = useAuth()

  if (isLoggedIn && isConsumer) {
    return <Redirect to="/club" />
  }

  return (
    <ThemeProvider
      theme={extendTheme({
        ...themes.pgaCoach,
        ...(isIntercomOverride ? themes.intercom : {}),
      })}
    >
      <Helmet>
        <title>MyPGA</title>
        <meta name="description" content="MyPGA | manage your journey" />
        <link rel="icon" href="/pga-coach-favicon.ico" />
      </Helmet>
      {isLoggedIn && isCoach ? <CoachLandingPage /> : <WelcomePage />}
    </ThemeProvider>
  )
}

export default withAuthenticatedRoute(WelcomeShell)
